import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SelectInput } from "../../../shared/dropdown/shared/select-input.class";
import { DataEndChannel } from "../../shared/interfaces/data-end-channel.interface";
import { ProjectRouteStation } from "../../shared/interfaces/project-route-station.interface";
import { ProjectImageBrightness } from "../../shared/interfaces/project-image-brightness.interface";
import { AlertTypes } from "../../../shared/alert/shared/alert-types";
import { ImageService } from "../../shared/services/image.service";
import { AlertService } from "../../../shared/alert/shared/alert.service";
import { DataEndChannelService } from '../../shared/services/data-end-channel.service';
import { SchemaRouteStationInfo } from '../../project-schema/shared/interfaces/schema-route-station-info.interface';
import { LedModeType } from '../../../device/shared/enums/led-mode-type';

@Component({
  selector: 'avs-test-area-brightness',
  templateUrl: './test-area-brightness.component.html',
  styleUrls: ['./test-area-brightness.component.css']
})
export class TestAreaBrightnessComponent implements OnChanges, OnInit {
  @Input() schemaInfo?: SchemaRouteStationInfo
  @Input() activeStation?: ProjectRouteStation
  @Input() dataEndChannels: DataEndChannel[] = [];
  // Lokales Formularmodell, wird bei jeder Eingabe-Änderung aus der Schema-Sicht befüllt
  public online: boolean = false;
  public ledMode: LedModeType = LedModeType.UNKNOWN;
  public brightness: number = 0;
  public maxBrightness: number = 0;
  public spontaneousMessages: boolean = false;
  public useSpontaneousMessages: boolean = false;
  public isKanalDropdownOpen: boolean = false;
  public selectedKanal?: SelectInput;
  public selectKanalInput: SelectInput[] = [];
  public isAnyValueChanged: boolean = false;
  public maxHelligskeitsWertChanged: boolean = false;
  public isLinked: boolean = false;
  public linkedClusterChannel?: DataEndChannel;
  public isChainZone: boolean = false;
  /*  public linkedModeController: number = 0; */
  public brightnessClusterChannelExists: boolean = false;

  constructor(private imageService: ImageService,
    private alertService: AlertService,
    private dataEndChannelService: DataEndChannelService) {
  }

  public ngOnInit(): void {

  }

  public ngOnChanges(): void {
    this.fillSelectDropdownBrightnessSettings(this.dataEndChannels);
    let ledBrightness = this.schemaInfo?.displays?.[0]?.data?.ledBrightness;
    this.online = this.schemaInfo?.online === true;
    this.ledMode = ledBrightness?.mode ?? LedModeType.UNKNOWN;
    this.brightness = ledBrightness?.brightness ?? 0;
    this.maxBrightness = ledBrightness?.maxBrightness ?? 0;
    this.spontaneousMessages = ledBrightness?.spontanBrightnessMsgs ?? false;
  }

  public onBrightnessInputValueChange(newValue: number): void {
    this.brightness = newValue;
    this.isAnyValueChanged = true;
    if (this.ledMode === LedModeType.MANUAL) {
      this.maxBrightness = newValue;
    }
  }

  public onMaxBrightnessInputValueChange(newValue: number): void {
    this.maxBrightness = newValue;
    this.maxHelligskeitsWertChanged = true;
    this.isAnyValueChanged = true;
    if (newValue === 0) {
      this.maxHelligskeitsWertChanged = false;
    }
  }

  public onKanelDropdownClicked(): void {
    if (this.selectKanalInput.length < 1) { return; }
    this.isKanalDropdownOpen = !this.isKanalDropdownOpen
  }

  public onSelectKanalItemClicked(selectItem: SelectInput): void {
    this.selectedKanal = selectItem;
    this.isKanalDropdownOpen = false;
  }

  public onSpontaneousReportChanged(value: boolean): void {
    this.spontaneousMessages = value;
    this.isAnyValueChanged = true;
  }

  public onSaveBtnClicked(): void {
    if (!this.activeStation) { return; }
    let brightnessParameter = {
      brightness: this.brightness,
      useSpontaneousMessages: this.spontaneousMessages,
      mode: this.ledMode,
      maxBrightness: this.maxBrightness,
      deKanal: this.selectedKanal?.id
    } as ProjectImageBrightness
    this.dataEndChannelService.updateBrightnessParameters(this.getDataEndChannelIdByDeKanal(brightnessParameter.deKanal!), brightnessParameter).subscribe((response) => {
      this.alertService.alert("Die Änderungen wurden erfolgreich gespeichert", AlertTypes.info);
      this.isAnyValueChanged = false;
    });
  }

  public getDataEndChannelIdByDeKanal(deKanal: number): number {
    let dataEndChannel = this.dataEndChannels.find(x => x.de === deKanal);
    if (dataEndChannel) {
      return dataEndChannel.id;
    }
    return 0;
  }

  private fillSelectDropdownBrightnessSettings(dataEndChannels: DataEndChannel[]): void {
    this.selectKanalInput = [];
    this.selectedKanal = undefined;
    if (!dataEndChannels) { return; }
    for (let channel of dataEndChannels) {
      if (channel.de > 190) {
        let select = {
          name: 'Kanal ' + channel.de,
          id: channel.de
        } as SelectInput
        if (!this.selectedKanal) {
          this.selectedKanal = select;
        }
        this.selectKanalInput.push(select);
      }
    }
    this.selectKanalInput.forEach(x => { if (x.id === 194) { this.selectedKanal = x } })
    this.linkedClusterChannel = undefined;
    this.brightnessClusterChannelExists = false;
    this.linkedClusterChannel = this.dataEndChannels.find(x => x.de === 194 && x.localbusAddress === 1 || x.localbusAddress === 2);
    if (this.linkedClusterChannel) {
      /*  if(this.linkedClusterChannel.localbusAddress === 2) {this.isChainZone = true;} */
      this.brightnessClusterChannelExists = this.linkedClusterChannel !== undefined ? true : false;

      let parsedFg04Settings = JSON.parse(this.linkedClusterChannel.fG04_Settings);
      let brightnessParameter = parsedFg04Settings?.brightnessParameter;
      if (brightnessParameter) {
        this.isLinked = brightnessParameter.LinkedMode
      }
      else {
        this.isLinked = false;
      }
    }
    this.selectedKanal = this.selectKanalInput.find(x => x.id === 194);
  }

  onSelectOption(event: any) {
    this.ledMode = event;
    this.isAnyValueChanged = true;
  }
}
